import { ref } from 'vue'

const COOKIE_NAME = 'kerialis_EC_cookie_consent';
const isCookiesAccepted = ref(localStorage.getItem(COOKIE_NAME) != null);

const useCookies = {
  setCookie: (value) => {
    localStorage.setItem(COOKIE_NAME, value);
    isCookiesAccepted.value = true
  }
}

export { isCookiesAccepted, useCookies }
